<template lang="pug">
#search.route-list-search(style="flex-grow: 3")
    input.text(type="text" placeholder="Номер маршрутного листа..." v-model="filter.search" v-on:keyup.enter="doFilter")
    md-button.md-icon-button.md-dense.md-primary(v-on:click="toggleFilterSettings")
      md-icon settings
    md-button.button-close.small.md-icon-button.md-accent(@click="resetFilter" v-show="hasFilter")
      md-icon close

    .dropdown.md-elevation-2(v-if="filterSettings" v-click-outside="hideFilterSettings")
      .search-md-menu-container.itineraries-search-setting
        .md-layout.filter-container
      
          //.md-layout-item.md-size-20.center-layout
            label Статус
          //.md-layout-item.md-size-80.with-pr.center-layout
            z-select(v-model="filter.status_id")
                option(value="all") Любой
                option(v-for="status in statuses" v-bind:value="status.id" v-bind:key="status.id") {{ status.message }}
            
            
            
        
          .md-layout-item.md-size-20.center-layout
            label Статус
          .md-layout-item.md-size-80.with-pr.center-layout
            multy-autocomplete(
              placeholder="Статус"
              display-property="message"
              property="message"
              return="id"
              v-bind:show-search-input="false"
              v-model="selectedStatuses"
              v-bind:showOnFocus="true"
              v-bind:items="statuses"
              id="routelist_status_id"
              name="routelist_status_id"
            )
            
          .md-layout-item.md-size-20.center-layout
            label Тип перевозки
          .md-layout-item.md-size-80.with-pr.center-layout
            z-select(v-model="filter.type")
                option(v-bind:value="null") Любой
                option(v-bind:value="1") Экспедирование
                option(v-bind:value="2") Внутренняя перевозка

          .md-layout-item.md-size-20.center-layout(v-if="stocks && stocks.length && parseInt(filter.type) === 2")
            label Склад отправления
          .md-layout-item.md-size-80.with-pr.center-layout(v-if="stocks && stocks.length && parseInt(filter.type) === 2")
            z-select(v-model="filter.from_stock_id")
              option(v-bind:value="null") Любой
              option(v-for="stock in stocks" v-bind:value="stock.id" v-bind:key="stock.id") {{ stock.name }}
      
          .md-layout-item.md-size-20.center-layout(v-if="stocks && stocks.length && parseInt(filter.type) === 2")
            label Склад назначения
          .md-layout-item.md-size-80.with-pr.center-layout(v-if="stocks && stocks.length && parseInt(filter.type) === 2")
            z-select(v-model="filter.to_stock_id")
                option(v-bind:value="null") Любой
                option(v-for="stock in stocks" v-bind:value="stock.id" v-bind:key="stock.id") {{ stock.name }}

          .md-layout-item.md-size-20.center-layout(v-if="stocks && stocks.length && parseInt(filter.type) === 1")
            label Склад экспедирования
          .md-layout-item.md-size-80.with-pr.center-layout(v-if="stocks && stocks.length && parseInt(filter.type) === 1")
            z-select(v-model="filter.stock_id")
                option(v-bind:value="null") Любой
                option(v-for="stock in stocks" v-bind:value="stock.id" v-bind:key="stock.id") {{ stock.name }}

          .md-layout-item.md-size-20.center-layout
            label Отправление
          .md-layout-item.md-size-80.with-pr.center-layout
            ZInputAutocomplete(
              label="Отправление (введите город или направление)"
              display-property="label"
              property="id"
              v-model="location.from"
              v-bind:default="filter.from_label"
              v-bind:callback="searchCitysAndZones"
              v-on:clear="clearLocation('from')"
              v-on:select="selectLocationFrom"
              id="itineraries_filter_location_from"
              name="itineraries_filter_location_from"
            )
      
          .md-layout-item.md-size-20.center-layout
            label Назначение
          .md-layout-item.md-size-80.with-pr.center-layout
            ZInputAutocomplete(
              label="Назначение (введите город или направление)"
              display-property="label"
              property="id"
              v-model="location.to"
              v-bind:default="filter.to_label"
              v-bind:callback="searchCitysAndZones"
              v-on:clear="clearLocation('to')"
              v-on:select="selectLocationTo"
              id="itineraries_filter_location_to"
              name="itineraries_filter_location_to"
            )

          .md-layout-item.md-size-20.center-layout
            label Водитель
          .md-layout-item.md-size-80.with-pr.center-layout
            autocomplete(
              label="Введите имя или логин для поиска" v-model="filter.driver_id" v-bind:default="filter.driver_label"
              v-bind:callback="searchUser" v-on:select="selectDriver"
              display-property="label" property="label" return="id"
              name="label"
            )

          .md-layout-item.md-size-20.center-layout
            label Экпедитор
          .md-layout-item.md-size-80.with-pr.center-layout
            autocomplete(
              label="Введите имя или логин для поиска" v-model="filter.forwarder_id" v-bind:default="filter.forwarder_label"
              v-bind:callback="searchUser" v-on:select="selectForwarder"
              display-property="label" property="label" return="id"
              name="label"
            )

          .md-layout-item.md-size-20.center-layout
            label Дата исполнения
          .md-layout-item.md-size-80.with-pr.center-layout
            md-field(md-theme="white" v-bind:class="{'md-has-value': !!filter.date}")
              datetime(name="from_date" input-class="md-input" type="date" v-bind:use12-hour="false" v-model="filter.date" v-bind:week-start="1" v-bind:phrases="{ ok: 'Ок', cancel: 'Отмена' }" placeholder="Дата исполнения")
      
          .md-layout-item.md-size-100.md-alignment-bottom-right.dropdown-button-container
            md-button.md-dense.md-primary.small(v-on:click="doFilter") Применить

      //.sort(v-if="usersStocks && usersStocks.length")
          z-select(v-model="stockType" v-on:change="filter")
              option(value="all") Склады (все)
              option(v-bind:value="1") Только мои    

</template>
<script>
  import ToggleMenu from '@/components/ToggleMenu'
  import autocomplete from '@/components/autocomplete'
  import ClickOutside from 'vue-click-outside'
  import ZSelect from '@/components/ZSelect'
  import ZInputAutocomplete from '@/components/ZInputAutocomplete';
  import MultyAutocomplete from '@/components/MultyAutocomplete';
  export default {
    components: {ToggleMenu, autocomplete, ZSelect, ZInputAutocomplete, MultyAutocomplete},
    directives: {ClickOutside},
    data() {
      return {
        loading: false,
        searchString: '',
        filterSettings: false,
        filteredStatuses: [],
        filteredTypes: [],
        selectedStatuses: [],
        filterDefault: {
          search: null,
          from_stock_id: null,
          to_stock_id: null,
          stock_id: null,
          from_city_id: null,
          to_city_id: null,
          from_zone_id: null,
          to_zone_id: null,
          from_label: null,
          to_label: null,
          date: null,
          type: null,
          status_id: [],
          forwarder_id: null,
          driver_id: null
        },
        location: {
          from: null,
          to: null
        },
        filter: {
          search: null,
          from_stock_id: null,
          to_stock_id: null,
          stock_id: null,
          from_city_id: null,
          to_city_id: null,
          from_zone_id: null,
          to_zone_id: null,
          date: null,
          type: null,
          status_id: [],
          forwarder_id: null,
          driver_id: null,
          forwarder_label: null,
          driver_label: null,
        },
      }
    },
    created() {
      this.setSearchString();
      this.getStocks();
      this.$nextTick(() => {
        if (this.$route.query && this.$route.query.custom_filter) this.filter = Object.assign({}, JSON.parse(this.$route.query.custom_filter));
        this.getRouteListStatuses().then(() => {
          this.getStatusesFromFilter();
          this.doFilter();
        });
      }); 
    },
    computed: {
      statuses() {
        return this.$store.state.deals.route_list_statuses || [];
      },
      hasFilter() {
        return Object.values(this.filter).find(item => Array.isArray(item) && item.length || !Array.isArray(item) && item);
      },
      stocks() {
        return this.$store.state.stock.stocks
      },
      user() {
        return this.$store.state.users.current;
      },
      usersStocks() {
        return (this.user && this.user.stocks_id) ? this.user.stocks_id : [];
      },
      isUserAgent() {
        return (this.user && this.user.groups_codes) ? !!(this.user.groups_codes.indexOf('agent')+1) : false;
      }
    },
    watch: {
      'filter.type'() {
        this.filter.from_stock_id = null;
        this.filter.to_stock_id   = null;
        this.filter.stock_id      = null;
      },
      'selectedStatuses'(value) {
        if (value) this.filter.status_id = value.map(item => item.id);
        else this.filter.status_id = [];
      }
    },
    methods: { 
      getStatusesFromFilter() {
        this.selectedStatuses = this.statuses.filter(status => this.filter.status_id.indexOf(status.id)+1);
      },
      toggleFilterSettings() {
        this.filterSettings = !this.filterSettings;
      },
      hideFilterSettings() {
        this.filterSettings = false;
      },
      getRouteListStatuses() {
        return this.$store.dispatch('deals/getRouteListStatuses');
      },
      selectDriver(value, user) {
        this.filter.driver_id = user.id;
        this.filter.driver_label = user.label;
      },
      selectForwarder(value, user) {
        this.filter.forwarder_id = user.id;
        this.filter.forwarder_label = user.label;
      },
      searchUser(searchString) {
        if (searchString && searchString.length < 3) return;
          let data = {
              page:       1,
              order_by:   'id',
              order_type: 'asc',
              count:      10,
              filter:     {
                model: [
                  ['login', '%', searchString], 'or',
                  ['email', '%', searchString], 'or',
                  ['fio',   '%', searchString]
                ], relation: []
              }
          };
                        
          return this.$store.dispatch('users/searchUsers', data).then(users => {
            if (!users || !users.length) return [];
            return users.map(item => {
              item.label = ((item.fio) ? (item.fio + ' (' + item.login + ')') : item.login)
              return item;
            });
          });
      },
      searchCitysAndZones(value) {
          if (!value || value.length < 3) return new Promise(resolve => resolve([]));
          return Promise.all([this.getCities(value), this.getZones(value)]).then(data => {
              let result = [];
              if (!data || !data.length) return result;
              data.map(dataArr => {
                  if (dataArr && dataArr instanceof Array && dataArr.length) result = result.concat(dataArr);
              });
              return result;
          }).catch(() => []);
      },
      getCities(value) {
          let filter = {model: [['name', '%', value]]};
          return this.$store.dispatch('cost/getCitiesNew', {page: 1, order_by: 'name', order_type: 'asc', count: 20, filter: filter}).then(result => {
              if (!result || !result.data) return [];
              return result.data.map(city => {
                  city.type  = 'city';
                  city.label = 'Город: ' + city.name;
                  return city;
              });
          });
      },
      getZones(value) {
          return this.$store.dispatch('stock/getZones', { name: value }).then(r => {
              if (!r) return [];
              return r.map(zone => {
                  zone.type  = 'zone';
                  zone.label = 'Направление: ' + zone.name;
                  return zone;
              });
          });
      },
      selectLocationFrom(id, value) {
        this.selectLocation('from', id, value);
      },
      selectLocationTo(id, value) {
        this.selectLocation('to', id, value);
      },
      selectLocation(type, id, value) {
        if (!value.type) return;
        this.clearLocation(type);
        let key = (type + '_' + value.type + '_id');
        this.$set(this.filter, key, value.id);
        this.$set(this.filter, (type + '_label'), value.label);
      },
      clearLocation(type) {
        this.$set(this.filter, (type + '_city_id'), null);
        this.$set(this.filter, (type + '_zone_id'), null);
        this.$set(this.filter, (type + '_label'), null);
        this.$set(this.filter, (type + '_label'), null);
      },

      //сброс фильтра
      resetFilter() {
        this.filter = Object.assign({}, this.filterDefault);
        this.$router.push({ name: this.$route.name, params: this.$route.params });
        this.$root.$emit('refresh-table', 'itinerary');
      },
      //общий фильтр
      doFilter() {
        this.$nextTick(() => {
          let query = (this.$route.query) ? Object.assign({}, this.$route.query) : {};
          if (this.hasFilter) query.custom_filter = JSON.stringify(Object.assign({}, this.filter));
          this.$router.push({ name: this.$route.name, params: this.$route.params, query: Object.assign({}, query)});
          this.$root.$emit('refresh-table', 'itinerary');
          this.hideFilterSettings();
        });
      },
      //инициализация строки поиска
      setSearchString() {
        if (this.$route.query.search) this.searchString = this.$route.query.search;
        else if (this.$route.query.search_string) this.searchString = this.$route.query.search_string;
      },
      getStocks() {
        return this.$store.dispatch('stock/getStocks');
      },
    }
  }
</script>
<style lang="sass">
  .route-list-search
    max-height: 90vh
    max-width: 100%
    .filter-container
      width: 100%
      .center-layout
        display: flex
        align-items: center
        justify-content: flex-start
      .with-pr
        padding-right: 15px
</style>



// WEBPACK FOOTER //
// ItinerariesToolbar.vue?c52852be